import { Component } from '@angular/core';

@Component({
  selector: 'app-warning-left-panel',
  templateUrl: './warning-left-panel.component.html',
  styleUrls: ['./warning-left-panel.component.css']
})
export class WarningLeftPanelComponent {

}
